import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=e2673790&scoped=true&"
import script from "./Recorder.vue?vue&type=script&lang=ts&"
export * from "./Recorder.vue?vue&type=script&lang=ts&"
import style0 from "./Recorder.vue?vue&type=style&index=0&id=e2673790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2673790",
  null
  
)

export default component.exports